import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'h-11 w-full rounded-md border border-card-line bg-input px-4 text-sm text-hi outline-none transition-colors',
        'placeholder:text-lo focus:border-accent focus:ring-2 focus:ring-[var(--winr-accent-soft)]',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
